import React from 'react'
import PropTypes from 'prop-types'
import DhsvBlogShareIcons from './share'

const DhsvPostHighlight = ({ row, data, list }) => {
  const backColor = data.fields.color ? data.fields.color : '#31363a'
  const opacity = data.fields.opacity ? data.fields.opacity : 1

  return (
    <div
      className={
        `blog-item highlight-post` +
        (!['magazin_2_spalten_left', 'magazin_2_spalten_right'].includes(row)
          ? ' small'
          : '')
      }
    >
      <div className="inner">
        <span className="spotlight-badge">
          <p>Spotlight</p>
        </span>
        {!data.fields.featured_advertisement ? (
          <DhsvBlogShareIcons
            links={data.sharelinks}
            color={data.fields.teaser_share_icon_color}
          />
        ) : null}
        <a href={data.link} className="post-link" />
        {data.fields.overlay && (
          <div
            className="overlay-block"
            style={{
              background: data.fields.overlay.background_colour,
              color: data.fields.overlay.text_colour,
            }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: data.fields.overlay.text }}
            />
            {data.fields.overlay.link && (
              <a
                className="button large"
                href={data.fields.overlay.link.url}
                target={data.fields.overlay.link.target}
              >
                {data.fields.overlay.link.title}
              </a>
            )}
          </div>
        )}
        {backColor != '#31363a' ? (
          <div
            className="image-shadow"
            style={{
              backgroundImage: `linear-gradient(rgba(49, 54, 58, 0) 0%, ${backColor} 100%)`,
              opacity: opacity,
            }}
          />
        ) : null}
        <a
          href={data.link}
          className="image"
          {...(data.post_thumbnail.large
            ? { 'data-bg': data.post_thumbnail.large }
            : {})}
          style={{
            //background: `linear-gradient(180deg, rgba(49,54,58,0) 0%, rgba(49,54,58,0.85) 98%), url(${data.post_thumbnail.large})`,
            background: `url(${data.post_thumbnail.large})`,
            backgroundSize: `cover`,
            backgroundPosition: `center center`,
          }}
        />
        <div className="meta">
          <ul>
            {data.categories
              ? data.categories.map((cat, key) => (
                  <li key={key}>
                    <a href={cat.link}>{cat.name}</a>
                  </li>
                ))
              : null}
            <li className="date" hidden>
              <a>{data.date_format}</a>
            </li>
          </ul>
          <h3>
            {list ? (
              data.title
            ) : (
              <a
                href={data.link.url}
                dangerouslySetInnerHTML={{ __html: data.title.rendered }}
              />
            )}
          </h3>
          <div className="excerpt">
            {data.fields.featured_advertisement ? ' ' : data.excerpt + ' '}
            <a href={data.link}>{data.readMore}</a>
          </div>
        </div>
      </div>
    </div>
  )
}

DhsvPostHighlight.propTypes = {
  row: PropTypes.string,
  data: PropTypes.object,
  list: PropTypes.bool,
  readMore: PropTypes.string,
}

export default DhsvPostHighlight
